import { defineStore } from 'pinia';

export const layoutStore = defineStore("layout", {
    state: () => {
        var menus = []
        var dataInsting = JSON.parse(localStorage.getItem("dataInsting"))
        if(dataInsting){
            menus = dataInsting.menus
        }

        return {  
            name: "default",
            menus: menus,
            loading:false,
            menuIdsMasterData: "admin>master>master-data",        
        }
    },

    actions: {
        setMenus(menu){
            this.menus = menu
        },
        change(name) {
            this.name = name
        },
        setLoading(v) {
            this.loading = v
        },
    }
})
